import { render, staticRenderFns } from "./IPReceiveSettings.vue?vue&type=template&id=b624f76a&scoped=true&"
import script from "./IPReceiveSettings.vue?vue&type=script&lang=js&"
export * from "./IPReceiveSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b624f76a",
  null
  
)

export default component.exports